// src/components/ui/HelperText.jsx
import React from "react";
import { cn } from "../../utils/cn";

const HelperText = ({ children, error = false, className, ...props }) => {
  if (!children) return null;

  return (
    <p
      className={cn(
        "mt-1 text-body-small",
        error ? "text-afrimed-error" : "text-afrimed-on-surface-variant",
        className
      )}
      {...props}
    >
      {children}
    </p>
  );
};

export default HelperText;